module.exports = __webpack_public_path__ + "static/media/robi.aace4600.jpg";